import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Stimulus — import Application from the same copy bundled in the midwest dist
// so controller classes and the runtime share a single Stimulus instance.
import { Application } from "@hotwired/stimulus"
import { registerMidwestControllers } from "@unabridged/midwest"

const application = Application.start()
registerMidwestControllers(application)
